export default __webpack_public_path__ + "static/link-light-2951f3a02157e5e5bb720ac4d82cd45f.png";